// import React, { useState, useEffect, useRef } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   IconButton,
//   Autocomplete,
// } from "@mui/material";
// import { Add, Remove } from "@mui/icons-material";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import moment from "moment/moment";
// import AutoComplete from "react-select";
// import medicineService from "../../../Services/medicineService";
// import dispenserPurchaseService from "../../../Services/dispenserPurchaseService";

// const AddPurchase = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [medicines, setMedicines] = useState([]);
//   const [search, setSearch] = useState("");
//   const [isOpen, setIsOpen] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [medicinesOptions, setMedicinesOptions] = useState([]);
//   const [distributorsOptions, setDistributorsOptions] = useState([]);

//   const navigate = useNavigate();
//   const medicineRef = useRef();

//   const getMedicines = async () => {
//     try {
//       const response = await medicineService.fetchAll();
//       setMedicines(response.medicines);
//     } catch (error) {
//       toast.error("Error fetching Medicines");
//     }
//   };

//   useEffect(() => {
//     if (medicines.length > 0) {
//       let array = [];
//       for (const medicine of medicines) {
//         array.push({
//           value: medicine.id,
//           label: `${medicine.medicine_name} (${medicine.price})`,
//         });
//       }
//       setMedicinesOptions(array);
//     }
//   }, [medicines]);

//   useEffect(() => {
//     //getPatients();
//     getMedicines();
//     //getDistributors();
//     medicineRef.current.focus();
//   }, []);

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleSelectMedicine = (id) => {
//     let medicine = medicines.find((m) => m.id === id);
//     if (!medicine) {
//       toast.error("Medicine not found!");
//       return;
//     }
  
//     const newProduct = {
//       medicine_id: medicine.id,
//       itemName: medicine.medicine_name,
//       quantity: 1,
//       unit_price: 0.00,
//       sale_price: 0.00,
//       total_price: 0.00,
//     };
  
//     setProducts((prevProducts) => [...prevProducts, newProduct]);
//     setSearch("");
//   };
  

//   const handleRemovePurchase = (index) => {
//     setProducts(products.filter((_, i) => i !== index));
//   };

//   const handleQuantity = (index, name, value) => {
//     setProducts((prevProducts) => {
//       return prevProducts.map((product, i) => {
//         if (i === index) {
//           let newQuantity = name === "quantity" ? Number(value) : product.quantity;
//           let newPrice = name === "unit_price" ? Number(value) : product.unit_price;
//           return {
//             ...product,
//             [name]: value,
//             total_price: newQuantity * newPrice,
//           };
//         }
//         return product;
//       });
//     });
//   };
  

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
  
//   //   if (products.length === 0) {
//   //     toast.error("At least one medicine must be added");
//   //     return;
//   //   }
  
//   //   let submitData = {
//   //     Stocks: products.map((p) => ({
//   //       medicine_id: p.medicine_id,
//   //       quantity: p.quantity,
//   //       unit_price: p.unit_price,
//   //       sale_price: p.sale_price,
//   //     })),
//   //   };
//   //   console.log("Submitting data:", JSON.stringify(submitData, null, 2));
//   //   try {
//   //     const response = await dispenserPurchaseService.create(submitData);
//   //     console.log("Response:", response);
  
//   //     if (response && response.data) {
//   //       navigate("/account/medicinestock");
//   //       toast.success("Purchase Created Successfully");
//   //     } 
//   //   } catch (error) {
//   //     console.error("API Error:", error.response ? error.response.data : error.message);
//   //     toast.error("Failed to create purchase. Please try again.");
//   //   }
//   // };
  

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("Submit button clicked");
  
//     if (products.length === 0) {
//       console.log("No products, stopping submission.");
//       toast.error("At least one medicine must be added");
//       return;
//     }
  
//     let submitData = {
//       Stocks: products.map((p) => ({
//         medicine_id: p.medicine_id,
//         quantity: p.quantity,
//         unit_price: p.unit_price,
//         sale_price: p.sale_price,
//       })),
//     };
//     console.log("Submitting data:", JSON.stringify(submitData, null, 2));

//     try {
//       const response = await dispenserPurchaseService.create(submitData);
//       console.log("API Response:", response);
//       toast.success("Purchase Created Successfully");
//       navigate("/account/medicinestock");
//     } catch (error) {
//       console.error("API Error:", error.response ? error.response.data : error.message);
//       toast.error("Failed to create purchase. Please try again.");
//     }
//   };
  
//   const totalPurchasePrice = products.reduce(
//     (sum, product) => sum + Number(product.total_price || 0),
//     0
//   );

//   return (
//     <>
//       <form onSubmit={handleSubmit} className="w-[90%] m-auto ">
//         <h1 className="m-[30px] text-center text-[#F07F1B] font-[900] text-[30px]">
//           Add Medicines Purchase
//         </h1>
//         <div className="mt-10 pb-4">
//           <div className="grid grid-cols-2 gap-2">
//           </div>

//           <hr className="mt-4" />
//           <div className="flex w-[50%] , mt-4 mb-8">
//             <AutoComplete
//               ref={medicineRef}
//               className={`w-full`}
//               options={medicinesOptions}
//               // value={selectedProduct}
//               onChange={(v) => handleSelectMedicine(v.value)}
//               placeholder="Search Medicine"
//             />
//           </div>
//           <div className="mt-4">
//             <table className="w-full border-collapse rounded-lg overflow-hidden shadow-xl shadow-gray-300">
//               <thead>
//                 <tr className="bg-primary text-white capitalize leading-normal text-left text-xs bg-[#374151]">
//                   <th className="p-3 w-[5%] whitespace-nowrap">Sr No.</th>
//                   <th className="p-3 w-[15%] whitespace-nowrap">Item Name</th>
//                   <th className="p-3 w-[8%] whitespace-nowrap">Units</th>
//                   <th className="p-3 w-[10%] whitespace-nowrap">
//                     Purchase Price/Unit
//                   </th>
//                   <th className="p-3 w-[10%] whitespace-nowrap">
//                     Sale Price/Unit
//                   </th>
//                   <th className="p-3 w-[10%] whitespace-nowrap">
//                     Total Amount
//                   </th>
//                   <th className="p-3 w-[8%] whitespace-nowrap">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {products.length > 0 ? (
//                   products.map((product, index) => (
//                     <tr
//                       key={index}
//                       className="text-xs border-t border-gray-200"
//                     >
//                       <td className="p-3 pl-4 w-[10%] font-bold text-primary">
//                         {index + 1}
//                       </td>
//                       <td className="p-3 w-[10%] font-bold">
//                         {product.itemName}
//                       </td>
//                       <td className="p-3 w-[8%]">
//                         <input
//                           value={product.quantity}
//                           type="number"
//                           name="quantity"
//                           className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                           onChange={(e) =>
//                             handleQuantity(index, e.target.name, e.target.value)
//                           }
//                         />
//                       </td>
//                       <td className="p-3 w-[8%]">
//                         <input
//                           value={product.unit_price}
//                           type="text"
//                           name="unit_price"
//                           className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                           onChange={(e) =>
//                             handleQuantity(index, e.target.name, e.target.value)
//                           }
//                         />
//                       </td>
//                       <td className="p-3 w-[10%]">
//                         <input
//                           value={product.sale_price}
//                           type="text"
//                           name="sale_price"
//                           className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                           onChange={(e) =>
//                             handleQuantity(index, e.target.name, e.target.value)
//                           }
//                         />
//                       </td>
//                       <td className="p-3 w-[10%]">{product.total_price}</td>
//                       <td className="p-3 w-[10%] text-center">
//                         <IconButton
//                           onClick={() => handleRemovePurchase(index)}
//                           color="error"
//                         >
//                           <Remove />
//                         </IconButton>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="12" className="text-center p-4 text-gray-500">
//                       No purchases added yet.
//                     </td>
//                   </tr>
//                 )}
//                 <tr className="bg-gray-100 font-bold">
//                   <td colSpan="11" className="p-3 text-sm text-right">
//                     Total: {totalPurchasePrice.toFixed(2)}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div className="text-center mt-[70px]">
//             <button 
//               className="bg-white text-[#F07F1B] font-semibold shadow-lg hover:bg-[#F07F1B] hover:text-white px-8 py-3 rounded-full duration-300"
//               onClick={(e) => handleSubmit(e)}
//               type="submit"
//               >
//                 Generate Invoice
//               </button>
//           </div>
//         </div>
//       </form>
//     </>
//   );
// };

// export default AddPurchase;


import React, { useState, useEffect, useRef } from "react";
import { IconButton } from "@mui/material";
import { Remove } from "@mui/icons-material";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import AutoComplete from "react-select";
import medicineService from "../../../Services/medicineService";
import dispenserPurchaseService from "../../../Services/dispenserPurchaseService";

const AddPurchase = () => {
  const [medicines, setMedicines] = useState([]);
  const [products, setProducts] = useState([]);
  const [medicinesOptions, setMedicinesOptions] = useState([]);

  const navigate = useNavigate();
  const medicineRef = useRef();

  const getMedicines = async () => {
    try {
      const response = await medicineService.fetchAll();
      setMedicines(response.medicines);
    } catch (error) {
      toast.error("Error fetching Medicines");
    }
  };

  useEffect(() => {
    if (medicines.length > 0) {
      const array = medicines.map((medicine) => ({
        value: medicine.id,
        label: `${medicine.medicine_name} (${medicine.price})`,
      }));
      setMedicinesOptions(array);
    }
  }, [medicines]);

  useEffect(() => {
    getMedicines();
    medicineRef.current?.focus();
  }, []);

  const handleSelectMedicine = (id) => {
    const medicine = medicines.find((m) => m.id === id);
    if (!medicine) {
      toast.error("Medicine not found!");
      return;
    }
    const newProduct = {
      medicine_id: medicine.id,
      itemName: medicine.medicine_name,
      quantity: 1,
      unit_price: 0.0,
      sale_price: 0.0,
      total_price: 0.0,
    };
    setProducts((prev) => [...prev, newProduct]);
  };

  const handleRemovePurchase = (index) => {
    setProducts(products.filter((_, i) => i !== index));
  };

  const handleQuantity = (index, name, value) => {
    // Prevent negative or zero quantity; allow 0 for prices but not negative
    if (name === "quantity" && Number(value) < 1) return;
    if ((name === "unit_price" || name === "sale_price") && Number(value) < 0) return;

    setProducts((prevProducts) =>
      prevProducts.map((product, i) => {
        if (i === index) {
          const newQuantity =
            name === "quantity" ? Number(value) : product.quantity;
          const newPrice =
            name === "unit_price" ? Number(value) : product.unit_price;
          return {
            ...product,
            [name]: value,
            total_price: newQuantity * newPrice,
          };
        }
        return product;
      })
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (products.length === 0) {
      toast.error("At least one medicine must be added");
      return;
    }
    const submitData = {
      Stocks: products.map((p) => ({
        medicine_id: p.medicine_id,
        quantity: p.quantity,
        unit_price: p.unit_price,
        sale_price: p.sale_price,
      })),
    };
    try {
      const response = await dispenserPurchaseService.create(submitData);
      toast.success("Purchase Created Successfully");
      navigate("/account/medicinestock");
    } catch (error) {
      console.error("API Error:", error.response ? error.response.data : error.message);
      toast.error("Failed to create purchase. Please try again.");
    }
  };

  const totalPurchasePrice = products.reduce(
    (sum, product) => sum + Number(product.total_price || 0),
    0
  );

  return (
    <div className="p-6">
      {/* HEADER */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[17px] font-[500] text-gray-800">
            Add Medicines Purchase
          </h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {products.length} item{products.length !== 1 ? "s" : ""} added
          </p>
        </div>

        <div className="flex items-center gap-3">
          {/* Medicine Search */}
          <div className="w-[280px]">
            <AutoComplete
              ref={medicineRef}
              options={medicinesOptions}
              onChange={(v) => handleSelectMedicine(v.value)}
              placeholder="Search & add medicine..."
              styles={{
                control: (base) => ({
                  ...base,
                  fontSize: "13px",
                  borderColor: "#e5e7eb",
                  borderRadius: "8px",
                  backgroundColor: "#f9fafb",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#d1d5db" },
                }),
                placeholder: (base) => ({ ...base, color: "#9ca3af" }),
                option: (base, state) => ({
                  ...base,
                  fontSize: "13px",
                  backgroundColor: state.isFocused ? "#f3f4f6" : "white",
                  color: "#1f2937",
                }),
              }}
            />
          </div>

          <button
            onClick={handleSubmit}
            type="button"
             className="relative overflow-hidden bg-gray-800 text-white text-[13px] font-[500] px-4 py-2 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"               
          >
            Generate Invoice
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-800 text-[11px] uppercase text-white">
              <th className="py-3 px-4 text-left">Sr No.</th>
              <th className="py-3 px-4 text-left">Item Name</th>
              <th className="py-3 px-4 text-left">Units</th>
              <th className="py-3 px-4 text-left">Purchase Price / Unit</th>
              <th className="py-3 px-4 text-left">Sale Price / Unit</th>
              <th className="py-3 px-4 text-left">Total Amount</th>
              <th className="py-3 px-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {products.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="py-10 text-center text-gray-400 text-[13px]"
                >
                  No purchases added yet. Search for a medicine above to begin.
                </td>
              </tr>
            ) : (
              products.map((product, index) => (
                <tr
                  key={index}
                  className="border-t hover:bg-gray-50 text-[13px]"
                >
                  <td className="py-3 px-4 text-gray-500">{index + 1}</td>
                  <td className="py-3 px-4 font-[500] text-gray-800">
                    {product.itemName}
                  </td>
                  <td className="py-3 px-4">
                    <input
                      value={product.quantity}
                      type="number"
                      name="quantity"
                      min="1"
                      className="bg-gray-50 border border-gray-200 px-3 py-1.5 text-[13px] rounded-lg focus:outline-none focus:border-gray-400 w-20"
                      onChange={(e) =>
                        handleQuantity(index, e.target.name, e.target.value)
                      }
                    />
                  </td>
                  <td className="py-3 px-4">
                    <input
                      value={product.unit_price}
                      type="number"
                      name="unit_price"
                      min="0"
                      className="bg-gray-50 border border-gray-200 px-3 py-1.5 text-[13px] rounded-lg focus:outline-none focus:border-gray-400 w-24"
                      onChange={(e) =>
                        handleQuantity(index, e.target.name, e.target.value)
                      }
                    />
                  </td>
                  <td className="py-3 px-4">
                    <input
                      value={product.sale_price}
                      type="number"
                      name="sale_price"
                      min="0"
                      className="bg-gray-50 border border-gray-200 px-3 py-1.5 text-[13px] rounded-lg focus:outline-none focus:border-gray-400 w-24"
                      onChange={(e) =>
                        handleQuantity(index, e.target.name, e.target.value)
                      }
                    />
                  </td>
                  <td className="py-3 px-4 font-[500] text-gray-800">
                    {Number(product.total_price).toFixed(2)}
                  </td>
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleRemovePurchase(index)}
                      className="bg-red-50 text-red-500 text-[12px] px-3 py-1 rounded-md hover:bg-red-100 transition-colors"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))
            )}

            {/* Total Row */}
            {products.length > 0 && (
              <tr className="border-t bg-gray-50">
                <td
                  colSpan={5}
                  className="py-3 px-4 text-right text-[13px] font-[500] text-gray-600"
                >
                  Grand Total
                </td>
                <td className="py-3 px-4 text-[13px] font-bold text-gray-800">
                  {totalPurchasePrice.toFixed(2)}
                </td>
                <td />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddPurchase;